var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('articles',{attrs:{"sport":_vm.sport}}),_c('news',{attrs:{"sport":_vm.sport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }